import { ResizeGapsScope } from '../resizeGapsScope';
import {
  createMouseHandler,
  resizeImmediately,
} from '../resizeGapsMouseHandler';
import { isEnabled } from '../utils/isEnabled';

import type { CSSProperties, MouseEvent } from 'react';
import type { Gap } from '../resizeGapsTypes';

export interface GapBoxStateProps {
  gap?: Gap;
  currentHeight?: number;
  positionCSS: CSSProperties;
  isResizing: boolean;
  isVisible: boolean;
}

export const mapStateToProps = (scope: ResizeGapsScope): GapBoxStateProps => {
  const { resizeGapsStore } = scope;

  const gap = resizeGapsStore.getGap();
  const isContainerExist = !!gap?.container;

  return {
    gap,
    currentHeight: Math.floor(gap?.layout?.height),
    positionCSS: gap
      ? {
          top: gap.layout.y,
          left: gap.layout.x,
          width: gap.layout.width,
          height: gap.layout.height,
        }
      : {},
    isResizing: resizeGapsStore.getIsResizing(),
    isVisible: isContainerExist && isEnabled(scope),
  };
};

export interface GapBoxDispatchProps {
  startDrag: (e: MouseEvent, gap: Gap) => void;
  setGapHeight: (height: number, gap: Gap) => void;
}

export const mapDispatchToProps = (
  scope: ResizeGapsScope,
): GapBoxDispatchProps => {
  const { editorAPI } = scope;

  return {
    setGapHeight: (height: number, gap: Gap) => {
      resizeImmediately(scope, gap, height);
    },
    startDrag: (e: MouseEvent, gap: Gap) => {
      editorAPI.mouseActions.registerMouseMoveAction(
        createMouseHandler(scope, e, gap),
        { event: e },
      );
    },
  };
};
